<template>
  <div class="page-brunch">
    <div class="navigation-wrapper">
    <TopNavbar></TopNavbar>
      <navbar />
      <AlertBox></AlertBox>
      </div>

      <Header :background_image="backgroundImage">
          <template 
            v-slot:title>
              MALICE
          </template>
          <template 
            v-slot:subtitle>
              vsak dan, za vse okuse
          </template>
      </Header>
      <DeliveryBanner></DeliveryBanner>

<div class="intro-chicken">
      <Intro>
        <template 
          v-slot:description>
            Privoščite si dnevno toplo, svežo in hranljivo malico! Izbirate lahko med pizzami pečenimi v krušni peči, najboljšim slovenskim piščancem (paniranim brez jajc in brez drobtin), hrustljavimi solatami in ostalimi jedmi, ki vas bodo nasitile med dolgim delovnim dnem.
        </template>
        <template 
          v-slot:title-last>
            ...pa dober tek!
        </template>
        
      </Intro>
      
      </div>


      <MenuSection :meals="brunchPizza" :isBrunch="true">
          <template 
          v-slot:title>
            Pizze
        </template>
      </MenuSection>

      <MenuSection :meals="brunchChicken" :isBrunch="true">
          <template 
          v-slot:title>
            Slovenski piščanec
        </template>
      </MenuSection>

      <MenuSection :meals="brunchSalad" :isBrunch="true">
          <template 
          v-slot:title>
            Solate
        </template>
      </MenuSection>

      <MenuSection :meals="brunchOther" :isBrunch="true">
          <template 
          v-slot:title>
            Ostale jedi
        </template>
      </MenuSection>
  
      <Guests :testimonials="testimonials" :gallery="gallery"></Guests>
      <Footer></Footer>
      <cookieConsent></cookieConsent>
  </div>
</template>

<style lang="scss">

@import '../components/variables.scss';

.page-pizzas {
    .subpage-header {
        background-image: url('../assets/pizza-header.jpg');
        margin-top:120px;
    }

    .pizzas-content {
        width:100%;
        max-width:1200px;
        margin:0 auto;
        padding: 1em;
        box-sizing: border-box;

        .pizzas-intro {
            margin:4em 0 0 0;
            line-height: 2;
            text-align: left;
            @include screen('mobile') {
              margin:2em auto;
            }
        }
    }
}
</style>

<script>
import backgroundImage from '@/assets/bg-pizza.jpg'
import TopNavbar from "@/components/TopNavbar/TopNavbar"
import Navbar from "@/components/MainNavbar/Navbar"
import Header from "@/components/Header/Header"
import MenuSection from "@/components/MenuSection/MenuSection"
import DeliveryBanner from "@/components/DeliveryBanner/DeliveryBanner"
import Intro from "@/components/Intro/Intro"
import Footer from "@/components/Footer/Footer"
import Guests from "@/components/Guests/Guests"
import AlertBox from "@/components/AlertBox/AlertBox"
import cookieConsent from "@/components/cookieConsent"

export default {
  name: "Home",
  data: () => ({
    backgroundImage,
    isDelivery: false,
    isBrunch: true,
    testimonials: [
        { name: 'Gal B.', message: 'Odlicno. Super postrežba, odlična hrana, prijazno osebje. Priporočam!'},
        { name: 'Matjaž L.', message: 'Nikoli razočarani. Prijazno osebje, zelo dobre pice, in ostala hrana.'},
        { name: 'Miha G.', message: 'Pizzeria s solidno ponudbo pic. Zelo prijazno in hitro osebje. Odlično točeno pivo. Priporočam!'}
    ]
  }),
  components: {
      TopNavbar,
      Navbar,
      AlertBox,
      Header,
      DeliveryBanner,
      Intro,
      Guests,
      Footer,
      MenuSection,
      cookieConsent
  },
  computed: {
        meals() {
        return this.$store.getters.allMeals
        },
         allBrunches() {
        return this.meals.filter(meal => meal.brunch === 1 || meal.types[0].id === 14);
        },
        brunchPizza() {
        return this.meals.filter(meal => meal.brunch === 1 && meal.types[0].id === 3 || meal.types[0].id === 6 || meal.types[0].id ===
          7 || meal.types[0].id === 5);
        },
        brunchSalad() {
        return this.meals.filter(meal => meal.brunch === 1 && meal.types[0].id === 4);
        },
        brunchOther() {
        return this.meals.filter(meal => meal.brunch === 1 && meal.types[0].id === 9);
        },
        brunchChicken() {
        return this.meals.filter(meal => meal.brunch === 1 && meal.types[0].id === 10 || meal.types[0].id === 14);
        },

        gallery() {
      return this.$store.getters.allGalleryPizzas
    },
	},
	mounted() {
        this.$store.dispatch("getMeals")
        this.$store.dispatch("getGalleryPizzas")
	},
};
</script>

<style lang="scss" scoped>


.header {
  position:relative;
}

.alert {
  position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -65%);
    color: white;
    background-color: #e1241b;
    padding: 1em;
    border-radius: 5px;
    font-size: 1.2rem;
}

.subpage-header {
    font-size:1.2rem;
}

.intro-chicken {
  position:relative;
  max-width: 1400px;
    margin: 0 auto;

  .chicken-image {
    position: absolute;
    top: 2em;
    left: 0;
    opacity: .4;
    width: 380px;
  }
}

.intro-image-wrapper {
  display:none;
}

</style>

